<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_applicants'] == 1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <span class="d-flex justify-content-between mb-2">
              <div class="d-flex justify-content-between">
                <div>
                  <label>From</label><input class="form-control" v-model="date_from" type="date" />
                </div>
                <div class="mx-1">
                  <label>To</label><input class="form-control" v-model="date_to" type="date" />
                </div>
                <div class="mt-4">
                  <b-button variant="primary" @click="FilterData"><i class="mdi mdi-filter"></i> Filter</b-button>
                </div>
              </div>
            </span>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show
                    <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select>
                    entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy" class="text-center">
                <template #table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner class="align-middle" type="grow" small></b-spinner>
                    <strong>No Data Found</strong>
                  </div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(name)="data">
                  {{ data.item.name }}
                </template>
                <template #cell(telephone)="data">
                  {{ data.item.telephone }}
                  <small class="text-primary fw-bold d-block">{{ data.item.email }}</small>
                </template>
                <template #cell(gender)="data">
                  {{ data.item.gender }}
                  <small class="text-primary fw-bold d-block">{{
                    Math.floor(
                      (new Date() - new Date(data.item.date_of_birth)) /
                      1000 /
                      60 /
                      60 /
                      24 /
                      365
                    )
                  }} years</small>
                </template>
                <template #cell(nin)="data">
                  {{ data.item.nin }}
                  <small class="text-primary fw-bold d-block">{{ data.item.nationality.name }}</small>
                </template>

                <template #cell(actions)="data">
                  <div v-if="userData.permissions['approve_applicants'] == 1">
                    <div v-if="data.item.status == 1" class="d-flex">
                      <router-link :to="{ path: '/newmember', query: { member_data: data.item } }" type="button"
                        class="btn btn-outline-primary btn-sm mx-1" :class="{ disabled: loader }" title="Approve">
                        <b-spinner v-if="loader" small="true"></b-spinner><i v-else
                          class="mdi mdi-pencil"></i></router-link>
                      <button @click.prevent="remove(data.item.id, data.item.name)"
                        class="btn btn-outline-danger btn-sm" :class="{ disabled: loader }">
                        <b-spinner v-if="loader" small="true"></b-spinner><i v-else class="mdi mdi-close-outline"></i>
                      </button>
                    </div>

                    <div v-if="data.item.status == 2" class="d-flex align-items-center">
                      <span class="text-success fw-bold">Approved</span>
                    </div>
                    <div v-if="data.item.status == 0" class="d-flex align-items-center">
                      <button @click.prevent="restore(data.item.id)" class="btn btn-outline-secondary btn-sm mx-1">
                        <i class="mdi mdi-undo"></i>
                      </button>

                      <span class="text-danger fw-bold">Rejected</span>
                    </div>
                  </div>
                  <!-- <div v-else class="text-center">
                    <span><i class="mdi mdi-close-outline fs-5 text-danger m-0"></i></span>
                    <small class="m-0 text-danger fw-bold d-block">No Permission</small>
                  </div> -->
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br /><br />
            <center>
              <span class="text-primary h6">You have no permission to View Members</span>
            </center>
          </div>
        </div>
      </div>
    </div>

    <b-toast id="reject-applicant" variant="warning" solid>
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-baseline">
          <b-img blank blank-color="#ff5555" class="mr-2" width="12" height="12"></b-img>
          <strong class="mr-auto">Notice!</strong>
          <small class="text-muted mr-2">42 seconds ago</small>
        </div>
      </template>
      This is the content of the toast. It is short and to the point.
    </b-toast>

    <b-modal id="reject-applicant" centered title="Reject Applicant" title-class="font-18" hide-footer>
      <form @submit.prevent="removeMember">
        <input v-model="id" type="hidden" />
        Are you sure you want to reject the Application for :
        <b> {{ name }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30 me-1" variant="secondary"
            @click="$bvModal.hide('reject-applicant')">Close</b-button>
          <button type="" class="btn btn-danger btn-sm" :class="{ disabled: loader2 }">
            <b-spinner v-if="loader2" small="true"></b-spinner>
            <div v-else><i class="mdi mdi-check-bold"></i> Yes</div>
          </button>
        </div>
      </form>
    </b-modal>

    <b-modal id="restore-applicant" centered title="Restore Applicant" title-class="font-18" hide-footer>
      <form @submit.prevent="restoreApplicant">
        <input v-model="id" type="hidden" />
        Are you sure you want to restore the Application for :
        <b> {{ name }}</b> ?
        <div class="form-group d-flex justify-content-end">
          <b-button type="button" class="btn w-30 me-1" variant="secondary"
            @click="$bvModal.hide('reject-applicant')">Close</b-button>
          <button type="" class="btn btn-danger btn-sm" :class="{ disabled: loader2 }">
            <b-spinner v-if="loader2" small="true"></b-spinner>
            <div v-else><i class="mdi mdi-check-bold"></i> Yes</div>
          </button>
        </div>
      </form>
    </b-modal>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import {
  applicantMethods,
  applicantComputed,
  savingpackageMethods,
  savingpackageComputed,
  countriesMethods,
  countriesComputed,
} from "@/state/helpers";

export default {
  page: {
    title: "Applicants",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Applicants",
      items: [
        { text: "Dashboard", to: "/" },
        { text: "Applicants", active: true },
      ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: "index", label: "#", visible: true },
        { key: "id", label: "ID", visible: false },
        { key: "name", label: "Name", visible: true },
        { key: "nin", label: "NIN", visible: true },
        { key: "gender", label: "Gender", visible: true },
        { key: "telephone", label: "Contact", visible: true },
        { key: "address", label: "Address", visible: true },
        { key: "actions", label: "Actions", visible: JSON.parse(localStorage.getItem("user")).permissions['approve_applicants'] },
      ],
      id: "",
      telephone: "",
      name: "",
      nationality: "",
      gender: "",
      address: "",
      dateofbirth: "",
      nin: "",
      date_of_joining: "",
      sacco_member_id: "",
      savingpackage: "",
      nokname: "",
      nokcontact: "",
      username: "",
      email: "",
      loader: false,
      loader2: false,
      date_to: new Date().toLocaleDateString("fr-CA"),
      date_from: new Date().toLocaleDateString("fr-CA"),
    };
  },
  computed: {
    ...applicantComputed,
    ...countriesComputed,
    ...savingpackageComputed,
    List() {
      return this.applicants.length;
    },
    Fields() {
      return this.fields.filter((field) => field.visible);
    },
    Items() {
      return this.applicants.map((d) => ({ ...d }));
    },
    IsBusy() {
      let a = false;
      if (this.applicants.length > 0) {
        a = false;
      } else {
        a = true;
      }
      return a;
    },
  },
  mounted() {
    this.fetchCountries();
    this.fetchApplicants();
    this.fetchSavingPackages();
    this.TotalRows = this.members.length;
    this.isBusy = false;
  },
  methods: {
    ...applicantMethods,
    ...countriesMethods,
    ...savingpackageMethods,

    restore(id, name) {
      this.id = id
      this.name = name
      this.$bvModal.show('restore-applicant')
    },

    async restoreApplicant() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "restore_application";
      const response = await axios.post(url, formData);
      if (response.status == 200) {
        this.fetchApplicants();
        this.$bvModal.hide('restore-applicant')
        this.$toast.success(
          `Application for ${response.data.applicant}, Restored!`
        );
      }
    },

    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(
      id,
      name,
      gender,
      telephone,
      nationality,
      address,
      dateofbirth,
      nin,
      date_of_joining,
      sacco_member_id,
      savingpackage,
      nokname,
      nokcontact,
      email,
      username
    ) {
      this.id = id;
      this.name = name;
      this.gender = gender;
      this.telephone = telephone;
      this.nationality = nationality;
      this.address = address;
      this.dateofbirth = dateofbirth;
      this.nin = nin;
      this.date_of_joining = date_of_joining;
      this.sacco_member_id = sacco_member_id;
      this.savingpackage = savingpackage.id;
      this.nokname = nokname;
      this.nokcontact = nokcontact;
      this.email = email;
      this.username = username;
      this.$bvModal.show("edit-member");
    },
    remove(id, name) {
      this.id = id;
      this.name = name;
      this.$bvModal.show("reject-applicant");
    },

    async editMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("gender", this.gender);
      formData.append("telephone", this.telephone);
      formData.append("nationality", this.nationality);
      formData.append("address", this.address);
      formData.append("dateofbirth", this.dateofbirth);
      formData.append("nin", this.nin);
      formData.append("date_of_joining", this.date_of_joining);
      formData.append("sacco_member_id", this.sacco_member_id);
      formData.append("nokname", this.nokname);
      formData.append("nokcontact", this.nokcontact);
      formData.append("savingpackage", this.savingpackage);
      formData.append("email", this.email);
      formData.append("username", this.username);
      let url = "/updatemember";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchMembers();
          this.$bvModal.hide("edit-member");
        }
      });
    },
    async removeMember() {
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/reject_application";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchApplicants();
          this.$bvModal.hide("reject-applicant");
          this.$toast.error(
            `Application for ${response.data.applicant}, Deleted!`
          );
        }
      });
    },
    FilterData() {
      this.filterMembers({ datefrom: this.date_from, dateto: this.date_to });
    },
  },
};
</script>
